
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clinical-trials/find/[...slug]",
      function () {
        return require("private-next-pages/clinical-trials/find/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clinical-trials/find/[...slug]"])
      });
    }
  